import { Menu as MuiMenu, MenuProps as MuiMenuProps } from '@material-ui/core';

export type MenuProps = MuiMenuProps;

export const Menu = MuiMenu;
